module.exports = __webpack_public_path__ + "img/sidebyside.199aea92.jpg";